<template>
  <DDR
    :active="false"
    :draggable="false"
    :rotatable="false"
    :minWidth="item.minWidth"
    :minHeight="item.minHeight"
    :key="item.id"
    :id="item.id"
    :acceptRatio="false"
    :parent="true"
    :axis="'xy'"
    v-model="item.transform"
    :renderContent="renderElementLayer">
  </DDR>
</template>
<script>

import DDR from 'yoyoo-ddr'
import 'yoyoo-ddr/dist/yoyoo-ddr.css'
import 'shaka-player/dist/controls.css'
import {TypeChooseLayer, TypePlayList} from '../constant'
import ComponentImpl from './VideoPlayerComponent.js'

export default {
  name: 'Draggable',
  components: {DDR},
  props: ['item', 'ratio'],
  data: function () {
    return {
      loading: {value: false},
      typeChooseLayer: TypeChooseLayer,
      items: [],
      singleVideo: null,
    }
  },
  computed: {},
  created () {
  },
  mounted () {
  },
  methods: {
    renderElementLayer () {
      if (this.item.extractData && (this.item.extractData.typeLayer != null && this.item.extractData.typeLayer != undefined)) {
        var item = this.item
        var attr = item.attr
        var data = item.extractData
        var transform = item.transform
        var _style
        var _styleWrapper
        var DynamicComponent
        switch (this.item.extractData.typeLayer) {
          case this.typeChooseLayer.TEXT : {
            if (this.item.extractData.isRun === true) {     /* Xử lý chữ chạy với loại văn bản */
              _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`
              _styleWrapper = `height:${transform.height}px;background:${attr.background}`
              DynamicComponent = ComponentImpl['textRunPlayer']
              return (
                <DynamicComponent fileId={data.id} idLayer={item.id} content={data.content}
                                  _styleWrapper={_styleWrapper} _style={_style}/>)
            } else {
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`

              DynamicComponent = ComponentImpl['textNormalPlayer']
              return (
                <DynamicComponent fileId={data.id} idLayer={item.id} content={data.content} _style={_style}/>)
            }
            break
          }
          case this.typeChooseLayer.IMAGE : {
            _style = `width:${transform.width}px;height:${transform.height}px;`
            DynamicComponent = ComponentImpl['imageSinglePlayer']
            return (
              <DynamicComponent fileId={data.id} idLayer={item.id} url={data.url} content={data.content}
                                _style={_style}/>)
            break
          }
          // case this.typeChooseLayer.VIDEO : {
          //   var posterUrl = '';
          //   _style = `width:${transform.width}px;height:${transform.height}px`;
          //   DynamicComponent = ComponentImpl['videoSinglePlayer']
          //   return (
          //       <DynamicComponent fileId={data.id} idLayer={item.id} manifestUrl={data.url} posterUrl={data.urlThumbnail}
          //                         _style={_style} muted={attr.isMuted}/>)
          //   break;
          // }
          case this.typeChooseLayer.VIDEO : {
            var posterUrl = ''
            let _styleContainer = `width:${transform.width}px;height:${transform.height}px; position: relative;background-color: #000;`
            _style = `position: absolute; top: 0; left: 0; width: 100%; height:100%;`
            DynamicComponent = ComponentImpl['videoSinglePlayer']
            return (
              <DynamicComponent fileId={data.id} idLayer={item.id} manifestUrl={data.url} posterUrl={data.urlThumbnail}
                                _styleContainer={_styleContainer} _style={_style} muted={attr.isMuted}
                                ratio={this.ratio} transform={transform}/>)
          }
          case this.typeChooseLayer.STREAM_VTV : {
            var posterUrl = ''
            _style = `width:${transform.width}px;height:${transform.height}px`
            DynamicComponent = ComponentImpl['videoSinglePlayer']
            return (
              <DynamicComponent fileId={data.id} idLayer={item.id} manifestUrl={data.url} posterUrl={data.urlThumbnail}
                                _style={_style} muted={attr.isMuted}/>)
          }
          case this.typeChooseLayer.PLAY_LIST : {
            _style = `width:${transform.width}px;height:${transform.height}px`
            if (data.type === TypePlayList.TEXT_RUN) {    /* Playlist loại chữ chạy */
              _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`
              _styleWrapper = `height:${transform.height}px;background:${attr.background}`
              DynamicComponent = ComponentImpl['textRunPlayListPlayer']
              return (
                <DynamicComponent idLayer={item.id} items={data} _styleWrapper={_styleWrapper}
                                  _style={_style}/>)
            } else if (data.type === TypePlayList.TEXT_NORMAL) { /* PlayList loại Chữ thường */
              _style = `height:${transform.height}px;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};line-height:${attr.lineHeight}px;
                          background:${attr.background};letter-spacing:${attr.letterSpacing}px;font-family:${attr.font};text-align:${attr.textAlign};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`
              DynamicComponent = ComponentImpl['textNormalPlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}/>)
            } else if (data.type === TypePlayList.IMAGE) {    /* PlayList loại Hình ảnh */
              _style = `width:${transform.width}px;height:${transform.height}px`
              DynamicComponent = ComponentImpl['imagePlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}/>)
            } else if (data.type === TypePlayList.VIDEO) {  /* PlayList loại Video */
              let _styleContainer = `width:${transform.width}px;height:${transform.height}px; position: relative;background-color: #000;`
              _style = `position: absolute; top: 0; left: 0; width: 100%; height:100%;`
              DynamicComponent = ComponentImpl['videoPlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style} _styleContainer={_styleContainer}
                                        muted={attr.isMuted} ratio={this.ratio} transform={transform}/>)
            } else if (data.type === TypePlayList.DOCUMENT) {  /* PlayList loại tài liệu */
              _style = `width:${transform.width}px;height:${transform.height}px`
              DynamicComponent = ComponentImpl['documentPlayListPlayer']
              return (<DynamicComponent items={data.playListDetailModels} idLayer={item.id} _style={_style}
                                        muted={attr.isMuted}/>)
            }
            break
          }
          case this.typeChooseLayer.YOUTUBE : {
            _style = `width:${transform.width}px;height:${transform.height}px`
            var urlVideo = `${data.url}?version=3&autoplay=1&loop=1&enablejsapi=1&modestbranding=1&controls=0&mute=${attr.isMuted === true ? 1 : 0}&disablekb=1&rel=0&showinfo=0&iv_load_policy=3&vq=hd720&playlist=${data.videoId}`
            DynamicComponent = ComponentImpl['youtubePlayer']
            return (<DynamicComponent idLayer={item.id} videoId={data.videoId} url={urlVideo} width={transform.width}
                                      isMuted={attr.isMuted}
                                      height={transform.height} _style={_style}/>)
            break
          }
          case this.typeChooseLayer.RSS : {
            _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`
            _styleWrapper = `height:${transform.height}px;background:${attr.background}`
            DynamicComponent = ComponentImpl['rssPlayer']
            return (
              <DynamicComponent fileId={data.id} idLayer={item.id} item={data}
                                _styleWrapper={_styleWrapper} _style={_style}/>)
          }
          case this.typeChooseLayer.DOCUMENT : {
            _style = `width:${transform.width}px;height:${transform.height}px`
            DynamicComponent = ComponentImpl['documentPlayer']
            return (
              <DynamicComponent fileId={data.id} idLayer={item.id} item={data} _style={_style}/>)
          }
          case this.typeChooseLayer.AREA_TEXT : {
            _style = `animation: scrollLeft ${attr.speed}s linear infinite;color:${attr.color};font-size:${attr.fontSize}px;font-weight:${attr.fontWeight};letter-spacing:${attr.letterSpacing}px;line-height:${transform.height}px;font-family:${attr.font};font-style:${attr.fontStyle};text-decoration:${attr.textDecoration};`;
            _styleWrapper = `height:${transform.height}px;background:${attr.background}`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} _styleWrapper={_styleWrapper}
                                  muted={attr.isMuted}
                                  _style={_style}/>)
          }
          case (this.typeChooseLayer.AREA_LEFT) : {
            let _styleContainer = `width:${transform.width}px;height:${transform.height}px; position: relative;background-color: #000;`;
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} muted={attr.isMuted} transform={transform}
                _styleContainer={_styleContainer}
                                ratio={this.ratio}  _style={_style}/>)
          }
          case (this.typeChooseLayer.AREA_RIGHT) : {
            let _styleContainer = `width:${transform.width}px;height:${transform.height}px; position: relative;background-color: #000;`;
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} muted={attr.isMuted} transform={transform}
                _styleContainer={_styleContainer}
                                ratio={this.ratio}  _style={_style}/>)
          }
          case (this.typeChooseLayer.FULL_SCREEN) : {
            let _styleContainer = `width:${transform.width}px;height:${transform.height}px; position: relative;background-color: #000;`;
            _style = `width:${transform.width}px;height:${transform.height}px`;
            DynamicComponent = ComponentImpl['centralPlayer']
            return (
                <DynamicComponent idLayer={item.id} items={data.playListDetailModels} muted={attr.isMuted} transform={transform}
                  _styleContainer={_styleContainer}
                                 ratio={this.ratio} _style={_style}/>)
          }
          case this.typeChooseLayer.WIDGET: {
            _style = `width:${transform.width}px;height:${transform.height}px`
            // new Function(data.script)();
            DynamicComponent = ComponentImpl['widgetPlayer']
            let jsx = h('div', {domProps: {innerHTML: data.html}, style: {width:`${transform.width}px`,height:`${transform.height}px`,'text-align': 'center','align-items': 'center',display: 'inline-flex'}})
            return (
              <DynamicComponent idLayer={item.id}
                                jsx={jsx}
                                items={item}
                                _script={data.script}
                                _html={data.html}
                                _style={_style}/>)
            // setTimeout(function () {
            //   new Function(data.script)();
            // })
            // return h("div", {domProps:{innerHTML: data.html}, style: {_style}})
          }
        }
      }
    },
  },
  watch: {},
  destroyed () {
  }
}
</script>

<style scoped>
video {
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/Draggable.vue